import {
    CREATE_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE,
    CREATE_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST,
    CREATE_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS,
    CREATE_USER_FORM_IRONING_AND_PACKING_INWARD_DETAILS,
    DELETE_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE,
    DELETE_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST,
    DELETE_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS,
    FETCH_SINGLE_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE,
    FETCH_SINGLE_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST,
    FETCH_SINGLE_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS,
    FETCH_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE,
    FETCH_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST,
    FETCH_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS,
    IRONING_AND_PACKING_INWARD_DETAILS_USERFORM_RESET,
    UPDATE_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE,
    UPDATE_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST,
    UPDATE_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS,
    FETCH_IRONING_AND_PACKING_INWARD_DETAILS_BY_ID_REQUEST,
    FETCH_IRONING_AND_PACKING_INWARD_DETAILS_BY_ID_SUCCESS,
    IRONING_AND_PACKING_INWARD_DETAILS_PO_DETAILS_DISABLED,
    FETCH_IRONING_AND_PACKING_INWARD_DETAILS_EDIT_QTY_SUCCESS,
    FETCH_IRONING_AND_PACKING_INWARD_DETAILS_EDIT_QTY_REQUEST,
    FETCH_IRONING_AND_PACKING_INWARD_DETAILS_EDIT_QTY_FAILURE,
    RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_IRONING_AND_PACKING_INWARD_ID,
    SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_IRONING_AND_PACKING_INWARD_ID
} from './ironingAndPackingInwardDetails.actionsType';

export const IRONING_AND_PACKING_INWARD_DETAILS = 'ironingAndPackingInwardDetails';

let initialState = {
    loading: false,
    ironingAndPackingInwardDetailsById: [],
    ironingAndPackingInwardDetails: [],
    editGridData: [],
    ironingAndPackingInwardDetailsForm: {
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0
    },
    selectedIroningAndPackingDetails: {},
    isPoDetailsDisabled: false,
    errorMessage: '',
    iperrorMessage: ''
};

export let ironingAndPackingInwardDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST:
        case FETCH_IRONING_AND_PACKING_INWARD_DETAILS_BY_ID_REQUEST:
        case FETCH_IRONING_AND_PACKING_INWARD_DETAILS_EDIT_QTY_REQUEST:
        case CREATE_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST:
        case FETCH_SINGLE_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST:
        case UPDATE_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST:
        case DELETE_IRONING_AND_PACKING_INWARD_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                ironingAndPackingInwardDetails: updatePayload
            };
        case FETCH_IRONING_AND_PACKING_INWARD_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                ironingAndPackingInwardDetailsById: updatePayload
            };
        case FETCH_IRONING_AND_PACKING_INWARD_DETAILS_EDIT_QTY_SUCCESS:
            return {
                ...state,
                loading: false,
                editGridData: updatePayload?.CUD || []
            };

        case CREATE_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                ironingAndPackingInwardDetailsForm: {
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isPoDetailsDisabled: false
            };
        case RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_IRONING_AND_PACKING_INWARD_ID:
            return {
                ...state,
                loading: false,
                editGridData: []
            };
        case FETCH_SINGLE_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedIroningAndPackingDetails: updatePayload,
                ironingAndPackingInwardDetailsForm: { ...updatePayload }
            };
        case UPDATE_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedIroningAndPackingDetails: {},
                ironingAndPackingInwardDetailsForm: {
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isPoDetailsDisabled: false
            };
        case DELETE_IRONING_AND_PACKING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                ironingAndPackingInwardDetailsForm: {
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                selectedIroningAndPackingDetails: {},
                isPoDetailsDisabled: false
            };

        case FETCH_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE:
        case FETCH_IRONING_AND_PACKING_INWARD_DETAILS_EDIT_QTY_FAILURE:
        case FETCH_SINGLE_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE:
        case CREATE_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE:
        case UPDATE_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE:
        case DELETE_IRONING_AND_PACKING_INWARD_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_IRONING_AND_PACKING_INWARD_DETAILS:
            return {
                ...state,
                loading: false,
                ironingAndPackingInwardDetailsForm: {
                    ...state.ironingAndPackingInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_IRONING_AND_PACKING_INWARD_ID:
            return {
                ...state,
                loading: false,
                editGridData: payload
            };
        case IRONING_AND_PACKING_INWARD_DETAILS_PO_DETAILS_DISABLED:
            return {
                ...state,
                isPoDetailsDisabled: payload
            };
        case IRONING_AND_PACKING_INWARD_DETAILS_USERFORM_RESET:
            return {
                ...state,
                ironingAndPackingInwardDetailsForm: {
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                selectedIroningAndPackingDetails: {},
                isPoDetailsDisabled: false
            };
        default:
            return state;
    }
};
